export const menuRoutes = [
    { parent: "/users", children: "/user" },
    { parent: "/regions" , children: "/region" },
    { parent: "/businesses", children: "/business" },

    { parent: "/documents", children: "/document" },
    { parent: "/sections", children: "/section" },
    { parent: "/snippets", children: "/snippet" },
    { parent: "/templates", children: "/template" },
    { parent: "/logos", children: "/logo" },

    { parent: "/table-styles", children: "/table-style" },
    { parent: "/text-styles", children: "/text-style" },
    { parent: "/list-styles", children: "/list-style" },

    { parent: "/bulk-actions", children: null },
  ];